import Navbar from "../../Components/NavBar/index";
import Footer from "../../Components/Footer/index";
import SEO from "../../Components/SEO/index";
import LocationsComponent from "../../Components/Locations/index";
import Body7 from "../../Components/Home-new/Body7";
import Body9 from "../../Components/Home-new/Body9";
import { LocationsDataProvider, useLocationsData } from "../../database/LocationsDataContext";
import { LocationsSkeleton, Body7Skeleton, Body9Skeleton } from "../../Components/Skeletons/Skeletons";

const LocationsPageContent = () => {
    const { data, isLoading } = useLocationsData();

    if (isLoading) {
        return (
            <>
                <LocationsSkeleton />
                <Body7Skeleton />
                <Body9Skeleton />
            </>
        );
    }

    return (
        <>
            <div >
                <LocationsComponent preloadedData={data.locations} />
            </div>
            <Body7 preloadedData={data.body7} />
            <Body9 preloadedData={data.body9} />
        </>
    );
};

const LocationsPage = () => {
    return (
        <LocationsDataProvider>
            <SEO pageName="locations" />
            <Navbar />
            <LocationsPageContent />
            <Footer />
        </LocationsDataProvider>
    );
};

export default LocationsPage;
